$( document ).ready(function() {
  let prev_arrow = '<button aria-label="prev" role="button" class="slick-slider-prev-btn"><span class="hidden">prev</span><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="28" r="27.5" stroke="#2F2929"/><path d="M34 28H21.5M21.5 28L27.5 22M21.5 28L27.5 34" stroke="#2F2929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> </button>';
  let next_arrow = '<button aria-label="next" role="button" class="slick-slider-next-btn"><span class="hidden">next</span><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="28" r="27.5" stroke="#2F2929"/><path d="M22 28H34.5M34.5 28L28.5 22M34.5 28L28.5 34" stroke="#2F2929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\n</button>';

  $('.pdp-media-slider').slick({
    dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    fade: true,
    prevArrow: prev_arrow,
    nextArrow: next_arrow
  })

  $('.pdp-media-slider-wrap-mob').slick({
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true
  });


  $('.pdp-media-wraper .item-image, .pdp-media-wraper .item-video').on('click', function () {
    let nr_ = $(this).attr('data-nr');
    $('.pdp-media-slider').slick('slickGoTo', nr_);
    $('.pdp-media-slider-wrap').addClass('open');
    $('body').addClass('overflow-hidden');
    mousemoveCustom ();
  });
  $('.pdp-close-media-slider').on('click', function () {
    $('.pdp-media-slider-wrap').removeClass('open').off('mousemove', ' .pdp-slider-images');
    $('body').removeClass('overflow-hidden');
  });

  function mousemoveCustom () {
    $('.pdp-media-slider-wrap').on('mousemove', ' .pdp-slider-images', function(e) {

      let original = $(this).find('.no-zoom'),
        magnified = $(this).find('.zoom'),
        x = e.offsetX,
        y = e.offsetY;

      original.css({
        "opacity": "0"
      });
      magnified.css({
        "opacity": "1",
        "left":  -x,
        "top":  -y
      });

    });

    $('.pdp-media-slider-wrap').on('mouseleave', ' .pdp-slider-images', function() {
      let original = $(this).find('.no-zoom');
      let magnified = $(this).find('.zoom');
      original.css({
        "opacity": "1"
      });
      magnified.css({
        "opacity": "0"
      });
    });
  }

  $('.bb-pdp-collapsible').on('click', function () {
    if($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().slideUp();
    } else {
      $(this).addClass('open');
      $(this).next().slideDown();
    }
  });

  $('.f-size-button').on('click', function () {
      $(this).toggleClass('open');
      $('.f-colors-button').removeClass('open');
      $('.pdp-color-product-wrap').removeClass('open');
      $('.f-size').toggleClass('open');
  });

  $('.f-colors-button').on('click', function () {
    $(this).toggleClass('open');
    $('.f-size-button').removeClass('open');
    $('.f-size').removeClass('open');
    $('.pdp-color-product-wrap').toggleClass('open');
  });

  $('.f-size label').on('click', function () {
    var size__data =  $(this).attr('data-value');
    if($(this).attr('data-value') == size__data){
      $('.f-size-button span.option-value-selected').text(size__data);
    }

    $('.f-size-button').removeClass('open');
    $('.f-size').removeClass('open');
  });

  $.fn.isInViewport = function (size = 400) {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height() - size;
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };


  var _bottomlineReviews = $('.pdp-info .spr-starrating');
  if(_bottomlineReviews.length) {
    _bottomlineReviews.on('click', function(){
      scrollTo('#shopify-product-reviews');
    });
  }

  var scrollTo = function (elem) {
    var _height = 0;
    var _announcementBar = $('.bb--announcement-bar.announcement-bar');
    var _headerWrapper = $('.header-wrapper');
    if(_announcementBar.length) {
      _height += _announcementBar.height();
    }
    if(_headerWrapper.length) {
      _height += _headerWrapper.height();
    }
    const _el = document.querySelector(elem);
    const top = _el.offsetTop - _height;
    window.scrollTo({
      left: 0,
      top: top,
      behavior: 'smooth'
    });
  }

  var timer = 0;
  var reUpdateReviews = function () {
    timer = setTimeout(function(){
      var _p = $('.spr-pagination');
      var _s = _p.find('a');
      if(_s.length) {
        _s.each(function () {
          var item = $(this);
          item.on('click', function(e){
            e.preventDefault();
            timer = 0;
            scrollTo('#shopify-product-reviews');
            reUpdateReviews();
          });
        });
      }
    }, 1500);
  }

  var _qty_available = $('.f-size [data-qty-available]');
  var _note = $('.inventory-note');
  if(_qty_available.length && _note.length) {
    _qty_available.each(function () {
      var item = $(this);
      item.on('click', function(){
       var _text = item.attr('data-qty-available');
       if(_text) {
         _note.removeClass('_hidden');
         _note.text(_text);
       } else {
         _note.addClass('_hidden');
         _note.text('');
       }
      });
    });
  }
  reUpdateReviews();

});

const container = document.querySelector(".pdp-info");
const media = document.querySelector(".pdp-media");
let active = false;

// custom zoom
if (typeof Object.assign != 'function') {
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
if (typeof Array.from != 'function') {
  Array.from = function (object) {
    return [].slice.call(object);
  };
}
var buildElement = function(str) {
  var tmp = document.implementation.createHTMLDocument('');
  tmp.body.innerHTML = str;
  return Array.from(tmp.body.children)[0];
};
var triggerEvent = function(el, name) {
  var event = document.createEvent('HTMLEvents');
  event.initEvent(name, true, false);
  el.dispatchEvent(event);
};

var defineZoomMobile = function () {
  var ZoomMobile = function (el, options) {
        this.el = el;
        this.zoomFactor = 1;
        this.lastScale = 1;
        this.offset = {
          x: 0,
          y: 0
        };
        this.initialOffset = {
          x: 0,
          y: 0,
        };
        this.options = Object.assign({}, this.defaults, options);
        this.setupMarkup();
        this.bindEvents();
        this.update();


        if (this.isImageLoaded(this.el)) {
          this.updateAspectRatio();
          this.setupOffsets();
        }

        this.enable();

      },
      sum = function (a, b) {
        return a + b;
      },
      isCloseTo = function (value, expected) {
        return value > expected - 0.01 && value < expected + 0.01;
      };

  ZoomMobile.prototype = {

    defaults: {
      tapZoomFactor: 2,
      zoomOutFactor: 1.3,
      animationDuration: 300,
      maxZoom: 2,
      minZoom: 1,
      draggableUnzoomed: true,
      lockDragAxis: false,
      setOffsetsOnce: false,
      use2d: true,
      zoomStartEventName: 'pz_zoomstart',
      zoomUpdateEventName: 'pz_zoomupdate',
      zoomEndEventName: 'pz_zoomend',
      dragStartEventName: 'pz_dragstart',
      dragUpdateEventName: 'pz_dragupdate',
      dragEndEventName: 'pz_dragend',
      doubleTapEventName: 'pz_doubletap',
      verticalPadding: 0,
      horizontalPadding: 0,
      onZoomStart: null,
      onZoomEnd: null,
      onZoomUpdate: null,
      onDragStart: null,
      onDragEnd: null,
      onDragUpdate: null,
      onDoubleTap: null
    },

    handleDragStart: function (event) {
      triggerEvent(this.el, this.options.dragStartEventName);
      if(typeof this.options.onDragStart == "function"){
        this.options.onDragStart(this, event)
      }
      this.stopAnimation();
      this.lastDragPosition = false;
      this.hasInteraction = true;
      this.handleDrag(event);
    },

    handleDrag: function (event) {
      var touch = this.getTouches(event)[0];
      this.drag(touch, this.lastDragPosition);
      this.offset = this.sanitizeOffset(this.offset);
      this.lastDragPosition = touch;
    },

    handleDragEnd: function () {
      triggerEvent(this.el, this.options.dragEndEventName);
      if(typeof this.options.onDragEnd == "function"){
        this.options.onDragEnd(this, event)
      }
      this.end();
    },

    handleZoomStart: function (event) {
      triggerEvent(this.el, this.options.zoomStartEventName);
      if(typeof this.options.onZoomStart == "function"){
        this.options.onZoomStart(this, event)
      }
      this.stopAnimation();
      this.lastScale = 1;
      this.nthZoom = 0;
      this.lastZoomCenter = false;
      this.hasInteraction = true;
    },

    handleZoom: function (event, newScale) {
      // a relative scale factor is used
      var touchCenter = this.getTouchCenter(this.getTouches(event)),
          scale = newScale / this.lastScale;
      this.lastScale = newScale;

      // the first touch events are thrown away since they are not precise
      this.nthZoom += 1;
      if (this.nthZoom > 3) {

        this.scale(scale, touchCenter);
        this.drag(touchCenter, this.lastZoomCenter);
      }
      this.lastZoomCenter = touchCenter;
    },

    handleZoomEnd: function () {
      triggerEvent(this.el, this.options.zoomEndEventName);
      if(typeof this.options.onZoomEnd == "function"){
        this.options.onZoomEnd(this, event)
      }
      this.end();
    },

    handleDoubleTap: function (event) {
      var center = this.getTouches(event)[0],
          zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
          startZoomFactor = this.zoomFactor,
          updateProgress = (function (progress) {
            this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
          }).bind(this);

      if (this.hasInteraction) {
        return;
      }

      this.isDoubleTap = true;

      if (startZoomFactor > zoomFactor) {
        center = this.getCurrentZoomCenter();
      }

      this.animate(this.options.animationDuration, updateProgress, this.swing);
      triggerEvent(this.el, this.options.doubleTapEventName);
      if(typeof this.options.onDoubleTap == "function"){
        this.options.onDoubleTap(this, event)
      }
    },

    computeInitialOffset: function () {
      this.initialOffset = {
        x: 0,
        y: 0,
      };
    },

    resetOffset: function() {
      this.offset.x = this.initialOffset.x;
      this.offset.y = this.initialOffset.y;
    },

    isImageLoaded: function (el) {
      if (el.nodeName === 'IMG') {
        return el.complete && el.naturalHeight !== 0;
      } else {
        return Array.from(el.querySelectorAll('img')).every(this.isImageLoaded);
      }
    },

    setupOffsets: function() {
      if (this.options.setOffsetsOnce && this._isOffsetsSet) {
        return;
      }

      this._isOffsetsSet = true;

      this.computeInitialOffset();
      this.resetOffset();
    },

    sanitizeOffset: function (offset) {
      var elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
      var elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
      var maxX = elWidth - this.getContainerX() + this.options.horizontalPadding,
          maxY = elHeight -  this.getContainerY() + this.options.verticalPadding,
          maxOffsetX = Math.max(maxX, 0),
          maxOffsetY = Math.max(maxY, 0),
          minOffsetX = Math.min(maxX, 0) - this.options.horizontalPadding,
          minOffsetY = Math.min(maxY, 0) - this.options.verticalPadding;

      return {
        x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
        y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
      };
    },

    scaleTo: function (zoomFactor, center) {
      this.scale(zoomFactor / this.zoomFactor, center);
    },

    scale: function (scale, center) {
      scale = this.scaleZoomFactor(scale);
      this.addOffset({
        x: (scale - 1) * (center.x + this.offset.x),
        y: (scale - 1) * (center.y + this.offset.y)
      });
      triggerEvent(this.el, this.options.zoomUpdateEventName);
      if(typeof this.options.onZoomUpdate == "function"){
        this.options.onZoomUpdate(this, event)
      }
    },

    scaleZoomFactor: function (scale) {
      var originalZoomFactor = this.zoomFactor;
      this.zoomFactor *= scale;
      this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
      return this.zoomFactor / originalZoomFactor;
    },

    canDrag: function () {
      return this.options.draggableUnzoomed || !isCloseTo(this.zoomFactor, 1);
    },

    drag: function (center, lastCenter) {
      if (lastCenter) {
        if(this.options.lockDragAxis) {
          // lock scroll to position that was changed the most
          if(Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
            this.addOffset({
              x: -(center.x - lastCenter.x),
              y: 0
            });
          }
          else {
            this.addOffset({
              y: -(center.y - lastCenter.y),
              x: 0
            });
          }
        }
        else {
          this.addOffset({
            y: -(center.y - lastCenter.y),
            x: -(center.x - lastCenter.x)
          });
        }
        triggerEvent(this.el, this.options.dragUpdateEventName);
        if(typeof this.options.onDragUpdate == "function"){
          this.options.onDragUpdate(this, event)
        }
      }
    },

    getTouchCenter: function (touches) {
      return this.getVectorAvg(touches);
    },

    getVectorAvg: function (vectors) {
      return {
        x: vectors.map(function (v) { return v.x; }).reduce(sum) / vectors.length,
        y: vectors.map(function (v) { return v.y; }).reduce(sum) / vectors.length
      };
    },

    addOffset: function (offset) {
      this.offset = {
        x: this.offset.x + offset.x,
        y: this.offset.y + offset.y
      };
    },

    sanitize: function () {
      if (this.zoomFactor < this.options.zoomOutFactor) {
        this.zoomOutAnimation();
      } else if (this.isInsaneOffset(this.offset)) {
        this.sanitizeOffsetAnimation();
      }
    },

    isInsaneOffset: function (offset) {
      var sanitizedOffset = this.sanitizeOffset(offset);
      return sanitizedOffset.x !== offset.x ||
          sanitizedOffset.y !== offset.y;
    },

    sanitizeOffsetAnimation: function () {
      var targetOffset = this.sanitizeOffset(this.offset),
          startOffset = {
            x: this.offset.x,
            y: this.offset.y
          },
          updateProgress = (function (progress) {
            this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
            this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
            this.update();
          }).bind(this);

      this.animate(
          this.options.animationDuration,
          updateProgress,
          this.swing
      );
    },

    zoomOutAnimation: function () {
      if (this.zoomFactor === 1) {
        return;
      }

      var startZoomFactor = this.zoomFactor,
          zoomFactor = 1,
          center = this.getCurrentZoomCenter(),
          updateProgress = (function (progress) {
            this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
          }).bind(this);

      this.animate(
          this.options.animationDuration,
          updateProgress,
          this.swing
      );
    },

    updateAspectRatio: function () {
      if(this.container.parentElement){
        this.unsetContainerY();
        this.setContainerY(this.container.parentElement.offsetHeight);
      }
    },

    getInitialZoomFactor: function () {
      var xZoomFactor = this.container.offsetWidth * 1.4/ this.el.offsetWidth;
      var yZoomFactor = this.container.offsetHeight * 1.4 / this.el.offsetHeight;

      return Math.min(xZoomFactor, yZoomFactor);
    },

    getAspectRatio: function () {
      return this.el.offsetWidth / this.el.offsetHeight;
    },

    getCurrentZoomCenter: function () {
      var offsetLeft = this.offset.x - this.initialOffset.x;
      var centerX = -1 * this.offset.x - offsetLeft / (1 / this.zoomFactor - 1);

      var offsetTop = this.offset.y - this.initialOffset.y;
      var centerY = -1 * this.offset.y - offsetTop / (1 / this.zoomFactor - 1);

      return {
        x: centerX,
        y: centerY
      };
    },

    getTouches: function (event) {
      var rect = this.container.getBoundingClientRect();
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
      var posTop = rect.top + scrollTop;
      var posLeft = rect.left + scrollLeft;

      return Array.prototype.slice.call(event.touches).map(function (touch) {
        return {
          x: touch.pageX - posLeft,
          y: touch.pageY - posTop,
        };
      });
    },

    animate: function (duration, framefn, timefn, callback) {
      var startTime = new Date().getTime(),
          renderFrame = (function () {
            if (!this.inAnimation) { return; }
            var frameTime = new Date().getTime() - startTime,
                progress = frameTime / duration;
            if (frameTime >= duration) {
              framefn(1);
              if (callback) {
                callback();
              }
              this.update();
              this.stopAnimation();
              this.update();
            } else {
              if (timefn) {
                progress = timefn(progress);
              }
              framefn(progress);
              this.update();
              requestAnimationFrame(renderFrame);
            }
          }).bind(this);
      this.inAnimation = true;
      requestAnimationFrame(renderFrame);
    },

    stopAnimation: function () {
      this.inAnimation = false;
    },

    swing: function (p) {
      return -Math.cos(p * Math.PI) / 2  + 0.5;
    },

    getContainerX: function () {
      return this.container.offsetWidth;
    },

    getContainerY: function () {
      return this.container.offsetHeight;
    },

    setContainerY: function (y) {
      return this.container.style.height = y + 'px';
    },

    unsetContainerY: function () {
      this.container.style.height = null;
    },

    setupMarkup: function () {
      this.container = buildElement('<div class="zoom-container"></div>');
      this.el.parentNode.insertBefore(this.container, this.el);
      this.container.appendChild(this.el);

      this.container.style.overflow = 'hidden';
      this.container.style.position = 'relative';

      this.el.style.webkitTransformOrigin = '0% 0%';
      this.el.style.mozTransformOrigin = '0% 0%';
      this.el.style.msTransformOrigin = '0% 0%';
      this.el.style.oTransformOrigin = '0% 0%';
      this.el.style.transformOrigin = '0% 0%';

      this.el.style.position = 'absolute';
      this.el.style.backfaceVisibility = 'hidden';
      this.el.style.willChange = 'transform';
    },

    end: function () {
      this.hasInteraction = false;
      this.sanitize();
      this.update();
    },

    /**
     * Binds all required event listeners
     */
    bindEvents: function () {
      var self = this;
      detectGestures(this.container, this);

      this.resizeHandler = this.update.bind(this)
      window.addEventListener('resize', this.resizeHandler);
      Array.from(this.el.querySelectorAll('img')).forEach(function(imgEl) {
        imgEl.addEventListener('load', self.update.bind(self));
      });

      if (this.el.nodeName === 'IMG') {
        this.el.addEventListener('load', this.update.bind(this));
      }
    },

    update: function (event) {
      if (event && event.type === 'resize') {
        this.updateAspectRatio();
        this.setupOffsets();
      }

      if (event && event.type === 'load') {
        this.updateAspectRatio();
        this.setupOffsets();
      }

      if (this.updatePlanned) {
        return;
      }
      this.updatePlanned = true;

      window.setTimeout((function () {
        this.updatePlanned = false;

        var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor,
            offsetX = -this.offset.x / zoomFactor,
            offsetY = -this.offset.y / zoomFactor,
            transform3d =   'scale3d('     + zoomFactor + ', '  + zoomFactor + ',1) ' +
                'translate3d(' + offsetX    + 'px,' + offsetY    + 'px,0px)',
            transform2d =   'scale('       + zoomFactor + ', '  + zoomFactor + ') ' +
                'translate('   + offsetX    + 'px,' + offsetY    + 'px)',
            removeClone = (function () {
              if (this.clone) {
                this.clone.parentNode.removeChild(this.clone);
                delete this.clone;
              }
            }).bind(this);

        if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
          this.is3d = true;
          removeClone();

          this.el.style.webkitTransform = transform3d;
          this.el.style.mozTransform = transform2d;
          this.el.style.msTransform = transform2d;
          this.el.style.oTransform = transform2d;
          this.el.style.transform = transform3d;
        } else {

          if (this.is3d) {
            this.clone = this.el.cloneNode(true);
            this.clone.style.pointerEvents = 'none';
            this.container.appendChild(this.clone);
            window.setTimeout(removeClone, 200);
          }

          this.el.style.webkitTransform = transform2d;
          this.el.style.mozTransform = transform2d;
          this.el.style.msTransform = transform2d;
          this.el.style.oTransform = transform2d;
          this.el.style.transform = transform2d;

          this.is3d = false;
        }
      }).bind(this), 0);
    },

    /**
     * Enables event handling for gestures
     */
    enable: function() {
      this.enabled = true;
    },

    disable: function() {
      this.enabled = false;
    },

    destroy: function () {
      window.removeEventListener('resize', this.resizeHandler);

      if (this.container) {
        this.container.remove();
        this.container = null;
      }
    }
  };
  var detectGestures = function (el, target) {
    var interaction = null,
        fingers = 0,
        lastTouchStart = null,
        startTouches = null,

        setInteraction = function (newInteraction, event) {
          if (interaction !== newInteraction) {

            if (interaction && !newInteraction) {
              switch (interaction) {
                case "zoom":
                  target.handleZoomEnd(event);
                  break;
                case 'drag':
                  target.handleDragEnd(event);
                  break;
              }
            }

            switch (newInteraction) {
              case 'zoom':
                target.handleZoomStart(event);
                break;
              case 'drag':
                target.handleDragStart(event);
                break;
            }
          }
          interaction = newInteraction;
        },

        updateInteraction = function (event) {
          if (fingers === 2) {
            setInteraction('zoom');
          } else if (fingers === 1 && target.canDrag()) {
            setInteraction('drag', event);
          } else {
            setInteraction(null, event);
          }
        },

        targetTouches = function (touches) {
          return Array.from(touches).map(function (touch) {
            return {
              x: touch.pageX,
              y: touch.pageY
            };
          });
        },

        getDistance = function (a, b) {
          var x, y;
          x = a.x - b.x;
          y = a.y - b.y;
          return Math.sqrt(x * x + y * y);
        },

        calculateScale = function (startTouches, endTouches) {
          var startDistance = getDistance(startTouches[0], startTouches[1]),
              endDistance = getDistance(endTouches[0], endTouches[1]);
          return endDistance / startDistance;
        },

        cancelEvent = function (event) {
          event.stopPropagation();
          event.preventDefault();
        },

        detectDoubleTap = function (event) {
          var time = (new Date()).getTime();

          if (fingers > 1) {
            lastTouchStart = null;
          }

          if (time - lastTouchStart < 300) {
            cancelEvent(event);

            target.handleDoubleTap(event);
            switch (interaction) {
              case "zoom":
                target.handleZoomEnd(event);
                break;
              case 'drag':
                target.handleDragEnd(event);
                break;
            }
          } else {
            target.isDoubleTap = false;
          }

          if (fingers === 1) {
            lastTouchStart = time;
          }
        },
        firstMove = true;

    el.addEventListener('touchstart', function (event) {
      if(target.enabled) {
        firstMove = true;
        fingers = event.touches.length;
        detectDoubleTap(event);
      }
    }, { passive: false });

    el.addEventListener('touchmove', function (event) {
      if(target.enabled && !target.isDoubleTap) {
        if (firstMove) {
          updateInteraction(event);
          if (interaction) {
            cancelEvent(event);
          }
          startTouches = targetTouches(event.touches);
        } else {
          switch (interaction) {
            case 'zoom':
              if (startTouches.length == 2 && event.touches.length == 2) {
                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
              }
              break;
            case 'drag':
              target.handleDrag(event);
              break;
          }
          if (interaction) {
            cancelEvent(event);
            target.update();
          }
        }

        firstMove = false;
      }
    }, { passive: false });

    el.addEventListener('touchend', function (event) {
      if(target.enabled) {
        fingers = event.touches.length;
        updateInteraction(event);
      }
    });
  };

  return ZoomMobile;
};
var ZoomMobile = defineZoomMobile();